import { render } from "./page.vue?vue&type=template&id=25f285c2"
import script from "./page.vue?vue&type=script&lang=js"
export * from "./page.vue?vue&type=script&lang=js"

import exportComponent from "/home/docuseal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"app/javascript/template_builder/page.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "25f285c2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('25f285c2', __exports__)) {
    api.reload('25f285c2', __exports__)
  }
  
  module.hot.accept("./page.vue?vue&type=template&id=25f285c2", () => {
    api.rerender('25f285c2', render)
  })

}


export default __exports__